import { GameView } from "./ui/GameView";

export function App() {
  return <GameView />;
}
